var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-element', _vm.hidden && 'd-none'],attrs:{"data-test":_vm.dataTest}},[(_vm.disabled)?[_c('FormInputButton',{attrs:{"disabled":true,"label":_vm.label,"required":_vm.required,"error":_vm.error,"dirty":_vm.dirty}},[_vm._v("\n      "+_vm._s(_vm.displayDate)+"\n    ")])]:[(_vm.label)?_c('FormLabel',_vm._b({},'FormLabel',{
        label: _vm.label,
        required: _vm.required,
        disabled: _vm.disabled,
        description: _vm.description,
        descriptionType: _vm.descriptionType,
        dirty: _vm.dirty,
        error: _vm.error,
        id: _vm.id,
        status: _vm.status
      },false)):_vm._e(),_c('CommonDatepicker',_vm._b({attrs:{"id":_vm.id,"value":_vm.date,"type":"date","use-utc":false,"typeable":_vm.mergedConfig.typeable,"placeholder":_vm.disabled ? '—' : _vm.placeholder,"disabled":_vm.disabled,"input-class":{
        'p-0': _vm.disabled,
        'form-control datepicker': true,
        'invalid': _vm.invalid && _vm.dirty,
        'bg-white': !_vm.disabled
      }},on:{"input":_vm.update,"blur":function($event){return _vm.$emit('blur')}}},'CommonDatepicker',_vm.mergedConfig,false))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }